import axios from 'axios'

const StudentFeedbackService = {
  async submit (data) {
    return axios.post('student/feedback', data)
  },

  async getLinkContext (token) {
    return axios.get('student/feedback/link-context', { params: { token } })
  },

  async myFeedback (params = {}) {
    return axios.get('student/feedback', { params })
  },

  async get (id) {
    return axios.get(`student/feedback/${id}`)
  }
}

export default StudentFeedbackService
